import { createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const previousStatementsFeatureKey = 'previousStatements';

export interface State {
  loadPreviousStatements: any;
  loadPreviousStatementsResponse: any;
  loadPreviousStatementsFailure: any;
}

export const initialState: State = {
  loadPreviousStatements: undefined,
  loadPreviousStatementsResponse: undefined,
  loadPreviousStatementsFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(actions.loadPreviousStatements, (state, { request }) => ({
    ...state,
    loadPreviousStatements: request
  })),
  on(actions.loadPreviousStatementsSuccess, (state, { response }) => ({
    ...state,
    loadPreviousStatementsResponse: response
  })),
  on(actions.loadPreviousStatementsFailure, (state, { error }) => ({
    ...state,
    loadPreviousStatementsFailure: error
  }))
);

export const getPreviousStatements = (state: State) => state.loadPreviousStatementsResponse;
